// Template 7 — "Class RTL" — Template 1 with its two main layout grids mirrored
// (hero content + course card swap sides, body content + sticky card swap sides)
// while text stays left-aligned. Premium indigo default accent.
import Template1 from "./Template1";

export default function Template7(props) {
  return <Template1 {...props} mirror signature="#4F46E5" signature2="#F59E0B" />;
}
